import initialState from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_SETTINGS_SUCCESS:
      return { ...state,
        limits: { min: payload.min_bet, max: payload.max_bet, win: payload.max_win },
        rtp: payload.rtp_coefficient,
        coeffs: payload.coefficients,
      }
      
    case actionTypes.START_GAME:
      return {
        ...state,
        placedAmount: payload.amount,
        lives: payload.playersCount,
        wrong_picks: initialState.wrong_picks,
        temp_pick: initialState.temp_pick,
        roundID: payload.game_id,
        gameStatus: 1,
        result: initialState.result,
      }  

    case actionTypes.SET_START_INFO: {
      const oldGame = Object.keys(payload.old_game)?.length ? {
        placedAmount: payload.old_game.amount,
        lives: payload.old_game.current_lives,
        gameSettings: { ...state.gameSettings, linesCount: payload.old_game.lines_count, playersCount: payload.old_game.lives },
        wrong_picks: payload.old_game.mistakes.map(t => ({ stepId: +(t.step - 1), glassId: +t.picked })),
        temp_pick: payload.old_game.pick,
        gameStatus: 1,
      } : {};
      return { ...state, gameStatus: 0, ...oldGame }
    }

    case actionTypes.SET_ROUND_PERIOD_TYPE:
      return { ...state, gameStatus: payload }

    case actionTypes.SET_IS_PROCESS:
      return { ...state, isProcess: payload }
    
    case actionTypes.SET_GAME_SETTINGS: {
      let newAutoPickData = state.gameSettings.autoPickData;
      if (state.gameSettings.isAutoPick
        && state.gameSettings.linesCount === 3
        && payload.linesCount === 2
        && state.gameSettings.autoPickData.indexOf('2') !== -1) {
          newAutoPickData = ''
      } else if (payload.autoPickData !== undefined) {
        newAutoPickData = payload.autoPickData;
      }
      return {
        ...state,
        gameSettings: { ...state.gameSettings, ...payload, autoPickData: newAutoPickData },
        lives: payload.playersCount || state.lives,
        result: initialState.result,
        wrong_picks: state.gameStatus === 0 ? initialState.wrong_picks : state.wrong_picks,
        temp_pick: state.gameStatus === 0 ? initialState.temp_pick : state.temp_pick,
      }
    }

    case actionTypes.PICK:
      return { ...state,
        temp_pick: payload,
      }

    case actionTypes.WRONG:

      return {
        ...state,
        wrong_picks: [...state.wrong_picks, { stepId: payload.stepId, glassId: payload.glassId }],
        lives: payload.lives,
      }

    case actionTypes.COMPLETE_GAME:
      return { ...state,
      gameStatus: 0,
      temp_pick: payload.temp_pick || state.temp_pick,
      result: payload.result,      
    }  

    case actionTypes.LOST:
      return {
        ...state,
        roundID: payload.game_id,
        lives: state.gameSettings.playersCount,
        result: payload.result,
        wrong_picks: [...state.wrong_picks, { stepId: payload.stepId, glassId: payload.glassId }],
        gameStatus: 0,
        temp_pick: initialState.temp_pick,
      }

    case actionTypes.CLEAN_WRONG_PICKS:
      return {
        ...state,
        wrong_picks: initialState.wrong_picks,
      }  

    default: return state;
  }
}